module.exports = __webpack_public_path__ + "static/media/owl1.33a468b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/animalImage/img/owl1.svg
// module id = 145
// module chunks = 0